var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide"},[_c('p',{staticClass:"gl-mb-7"},[_vm._v("\n    "+_vm._s(_vm.__(
        'Stay in your workflow with contextual panels. Select an issue to view its details right alongside your list, so you can quickly review, edit, and move on to the next task.',
      ))+"\n  ")]),_vm._v(" "),_c('illustration')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }